import i18n from '../../i18n';
import { ATS } from '../../interfaces';
import { SubscribedProduct } from '../../queries/ats/me/products/types';

export function createSubscriptionStatus(item: SubscribedProduct) {
  const { SubscriptionType } = ATS;
  const { BOUGHT, RENTED } = SubscriptionType;

  const status = item.type === 'rental' ? RENTED : BOUGHT;

  return {
    status,
    text: item.type === 'rental' ? i18n.t<string>('rented') : i18n.t<string>('bought'),
  };
}
